/**
 * Recover plain markdown when assistant content was accidentally stored as
 * Python repr of LangChain content blocks, e.g. "[{'type': 'text', 'text': '...'}]".
 */

function blockTextFromRecord(block: Record<string, unknown>): string {
  if (block.type === 'text' && typeof block.text === 'string') {
    return block.text
  }
  return ''
}

function extractFromBlockArray(blocks: unknown[]): string {
  const parts: string[] = []
  for (const block of blocks) {
    if (typeof block === 'string') {
      parts.push(block)
      continue
    }
    if (block && typeof block === 'object') {
      const t = blockTextFromRecord(block as Record<string, unknown>)
      if (t) parts.push(t)
    }
  }
  return parts.join('')
}

function looksLikeReprContentBlocks(s: string): boolean {
  const t = s.trim()
  return t.startsWith('[{') && t.includes("'type'") && t.includes("'text'")
}

/** Normalize assistant message body before display or persistence merge. */
export function coerceAssistantMessageContent(content: string): string {
  if (!content) return content
  const trimmed = content.trim()
  if (!trimmed.startsWith('[')) return content

  if (looksLikeReprContentBlocks(trimmed)) {
    try {
      const jsonish = trimmed
        .replace(/'/g, '"')
        .replace(/\bTrue\b/g, 'true')
        .replace(/\bFalse\b/g, 'false')
        .replace(/\bNone\b/g, 'null')
      const parsed = JSON.parse(jsonish) as unknown
      if (Array.isArray(parsed)) {
        const recovered = extractFromBlockArray(parsed)
        if (recovered.trim()) return recovered
      }
    } catch {
      /* fall through */
    }
  }

  try {
    const parsed = JSON.parse(trimmed) as unknown
    if (Array.isArray(parsed)) {
      const recovered = extractFromBlockArray(parsed)
      if (recovered.trim()) return recovered
    }
  } catch {
    /* not JSON array */
  }

  return content
}
